import { useEffect } from "react";
import type { FieldError as HookFieldError } from "react-hook-form";
import FieldError from "./errors/FieldError.tsx";

declare global {
	interface Window {
		turnstile: {
			render: (
				matcher: string,
				config: {
					sitekey: string;
					callback: (token: string) => void;
					"error-callback": (token: string) => void;
				},
			) => string;
			remove: (id: string) => void;
		};

		turnstileSuccess: (token: string) => void;
		turnstileError: (err: unknown) => void;
		turnstileExpired: () => void;
	}
}

export default function Turnstile({
	onTokenChange,
	className = "",
	error,
}: {
	className?: string;
	onTokenChange: (token: string | null) => void;
	error?: HookFieldError;
}) {
	useEffect(() => {
		const widgetId = window.turnstile.render("#turnstile-container", {
			callback: onTokenChange,
			"error-callback": (err: unknown) => {
				console.error("Turnstile error", err);
				onTokenChange(null);
			},
			sitekey: import.meta.env.PUBLIC_ENV__TURNSTILE_SITE_ID,
		});

		return () => window.turnstile.remove(widgetId);
	}, [onTokenChange]);

	return (
		<div>
			<div
				id="turnstile-container"
				className={`cf-turnstile mx-auto w-full block ${className}`}
				data-theme="dark"
				data-callback="turnstileSuccess"
				data-error-callback="turnstileError"
				data-expired-callback="turnstileExpired"
				data-sitekey={`${import.meta.env.PUBLIC_ENV__TURNSTILE_SITE_ID}`}
			/>
			<FieldError error={error} />
		</div>
	);
}
